import { createSelector } from 'reselect'
import findFilter, { findFilterTab } from 'helpers/filter/findFilter'
import filterTabs from 'helpers/enums/filters/tabs'

const getFilter = (state, entityUID) => (
	findFilter(state.store.categories, entityUID)
	|| findFilter(state.store.standard, entityUID)
)

const getTab = (state, entityUID) => {
	const filtersByTab = {
		[filterTabs.REGULAR_TAB]: state.store.categories,
		[filterTabs.STANDARDS_TAB]: state.store.standard,
	}
	return findFilterTab(filtersByTab, entityUID)
}

const storeFiltersSelector = createSelector(
	[ getFilter, getTab ],
	(filter, tab) => ({
		tab: tab || filterTabs.REGULAR_TAB,
		filter,
	})
)

export default storeFiltersSelector
